import React, { useState } from 'react';
import './LoginPage.css';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import SharkHeader from '../components/SharkHeader';
import { FaUser, FaLock } from 'react-icons/fa';

const LoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isProcessing, setIsProcessing] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();


  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');

    if (!username || !password) {
      setError('Please enter both username and password.');
      return;
    }

    setIsProcessing(true);

    try {
      const appendQueryParams = (url) => {
        const queryParams = new URLSearchParams(window.location.search);
        return `${url}?${queryParams.toString()}`;
      };

      const requestUrl = appendQueryParams('https://8eue7g7jmd.execute-api.us-east-1.amazonaws.com/prod/google-login');

      const response = await axios.post(requestUrl, {
        username,
        password
      });

      const redirectURI = response.data.redirectURI;
      sessionStorage.setItem('redirectURI', redirectURI);
      navigate('/consent');
    } catch (err) {
      setError('Your username or password is incorrect.');
    } finally {
      setIsProcessing(false);
    }
  };


  //   const handleBack = () => {
  //     window.history.back(); // Go to previous page
  //   };

  return (
    <div className="container">
      {/* <button className="back-button" onClick={handleBack}>←</button> */}
      <SharkHeader />
      <form className="login-form" onSubmit={handleLogin}>
        <div className="input-group">
          <FaUser className="input-icon" />
          <input
            type="text"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
        </div>
        <div className="input-group">
          <FaLock className="input-icon" />
          <input
            type={showPassword ? 'text' : 'password'}
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        <div className="show-password">
          <input
            type="checkbox"
            id="showPassword"
            checked={showPassword}
            onChange={(e) => setShowPassword(e.target.checked)}
          />
          <label htmlFor="showPassword">Show Password</label>
        </div>
        {error && (
          <div className="error-box">
            <div className="error-title">Login Failed!</div>
            <div className="error-description">{error}</div>
          </div>
        )}
        <button type="submit" className="login-button" disabled={isProcessing}>
          {isProcessing ? 'Processing...' : 'Login'}
        </button>
      </form>
    </div>
  );
};

export default LoginPage;
